module.exports = __webpack_public_path__ + "static/img/t48.fe3dc701.png";